export const GetCurrentUser = (api) => {
    return api.get("/api/v1/Account/User")
}

export const UpdateAcceptedAgreementsVersion = (api, userId, accepptedAgreementsVersion) => {
    return api.post(`/api/v1/Account/updateAcceptedAgreementsVersion?userId=${userId}&agreementsVersion=${accepptedAgreementsVersion}`, null)
}